var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.moduleComponent)?_c('div',{staticClass:"d-flex flex-grow-1"},[_c(_vm.moduleComponent,{tag:"component",staticClass:"flex-1",attrs:{"module-name":_vm.module}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }